import React from 'react';
import { useSelector } from 'react-redux';

const ColorLegend = (props) => {
    const colorCodes = useSelector((state) => state.plannedItemState.colorCodes);

    const components = colorCodes.map((cc) => {
        const style = {color: cc.hexColor}
        return (<li className='legend margin-for-legend' key={cc.name} style={style}><p>{cc.name}</p></li>)
    });

    return (
        <ul className="legend-container">
            {components}
        </ul>
    );
};

export default ColorLegend;